;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.quote', [
      'kilo.routes.quote.show',
      'kilo.routes.quote.list'
    ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {

    var parentState = {
      name: 'quote',
      url: '/quote',
      resolve: {},
      abstract: true
    }

    $stateProvider.state(parentState)
  }
})(window.angular)
